import React, { Component } from "react";
import PropTypes from "prop-types";
import firebase from "firebase";
import "firebaseui/dist/firebaseui.css";
import { translate } from "react-i18next";

function getSignInSuccessUrl(redirect) {
    return (
        process.env.REACT_APP_SIGN_IN_SUCCESS_URL +
        (redirect ? `#!${redirect}` : "")
    );
}

function uiConfig(redirect) {
    return {
        signInSuccessUrl: getSignInSuccessUrl(redirect),
        signInOptions: [
            // Leave the lines as is for the providers you want to offer your users.
            firebase.auth.GoogleAuthProvider.PROVIDER_ID,
            firebase.auth.FacebookAuthProvider.PROVIDER_ID,
            firebase.auth.EmailAuthProvider.PROVIDER_ID
        ],
        // Terms of service url.
        tosUrl: process.env.REACT_APP_TOS_URL
    };
}

function loadJS(file, callback, err) {
    const jsElm = document.createElement("script");
    jsElm.type = "application/javascript";
    jsElm.src = file;

    jsElm.onload = callback;
    jsElm.onerror = err;

    document.body.appendChild(jsElm);
}

if (!window.firebase) {
    window.firebase = firebase;
}

let ui;

class FirebaseAuthUI extends Component {
    static propTypes = {
        i18n: PropTypes.object.isRequired,
        redirect: PropTypes.string
    };

    state = {
        firebaseui: false
    };

    componentWillMount() {
        let { i18n: { language } } = this.props;
        if (language === "zh") {
            language = "zh_tw";
        }
        // Unfortunately, this is the only way you can load
        // firebaseui with the correct locale without
        // building the source code for each locale.
        if (!window.firebaseui) {
            loadJS(
                `https://www.gstatic.com/firebasejs/ui/2.5.1/firebase-ui-auth__${language}.js`,
                this.onFirebaseLoad,
                this.onFirebaseError
            );
        } else {
            this.setState({ firebaseui: true });
        }
    }

    onFirebaseLoad = () => {
        this.setState({ firebaseui: true });
    };

    onFirebaseError = () => {};

    componentWillUnmount() {
        if (this.ui) {
            this.ui.reset();
        }
    }

    firebaseContainerDidMount = node => {
        if (node) {
            if (!ui) {
                ui = new window.firebaseui.auth.AuthUI(firebase.auth());
            }
            ui.start(node, uiConfig(this.props.redirect));
            this.ui = ui;
        }
        this.node = node;
    };

    render() {
        if (!this.state.firebaseui) {
            return <div />;
        }
        return (
            <div
                ref={this.firebaseContainerDidMount}
                className="firebaseAuthUI"
            />
        );
    }
}

export default translate("translation")(FirebaseAuthUI);



// WEBPACK FOOTER //
// ./src/components/FirebaseAuthUI.jsx